export enum RecurringInvoiceEventType {
  ProfileAccountingComplianceFail = 'profile.accounting.comply.failed',
  ProfileCompleted = 'profile.completed',
  ProfileCreated = 'profile.created',
  ProfileDeleted = 'profile.deleted',
  ProfileDocumentCreated = 'profile.document.created',
  ProfileDocumentDraftCreated = 'profile.document.draft.created',
  ProfileEdited = 'profile.edited',
  ProfilePaused = 'profile.paused',
  ProfileScheduleActionFail = 'profile.scheduler.action.failed',
  ProfileScheduleActionFailSend = 'profile.scheduler.action.failed.send',
  ProfileScheduleActionSuccess = 'profile.scheduler.action.succeeded',
  ProfileScheduleSubscriptionFail = 'profile.scheduler.subscription.failed',
  ProfileStarted = 'profile.started',
}
